import { render, staticRenderFns } from "./SFXAdd.vue?vue&type=template&id=e7d7d71a&"
import script from "./SFXAdd.vue?vue&type=script&lang=js&"
export * from "./SFXAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports